const cloud_path_prefix = "/cloud";
//话术库
const talklib_path = cloud_path_prefix + "/talklib"
const talklib_create = talklib_path + '/task/create'
const talllib_edit = talklib_path + '/task/edit/'
//拓客引流
const mobile_friend_drainage = '/cloud/drainage/mobilefriend'
const drainage_path = cloud_path_prefix + '/drainage';
const mobile_friend_path = drainage_path + '/mobilefriend';//拓客引流-手机号加好友
const mobile_friend_path_manage = mobile_friend_path + '/manage/';

const mobile_friend_path_manage_task = mobile_friend_path + '/task/';//创建任务文件
const mobile_friend_path_manage_create_task = mobile_friend_drainage + '/task/create';//创建任务页面
const mobile_friend_path_manage_create_task_edit = mobile_friend_drainage + '/task/edit/';//编辑任务页面
const mobile_friend_path_manage_create_task_copy = mobile_friend_drainage + '/task/copy/'//复制任务页面

const mobile_friend_path_manage_talk_details = mobile_friend_path_manage + 'talkdetails/';//跳转详情页面


const groupchat_friend_drinage = '/cloud/drainage/groupchatfriend'
const groupchat_friend_path = drainage_path + '/groupchatfriend';//拓客引流-群加好友
const groupchat_friend_path_manage = groupchat_friend_path + '/manage/';
const groupchat_friend_path_manage_task = groupchat_friend_path + '/task/'//群的新建任务
const groupchat_friend_path_manage_create_task = groupchat_friend_drinage + '/task/create';
const groupchat_friend_path_manage_create_task_edit = groupchat_friend_drinage + '/task/edit/';
const groupchat_friend_path_manage_create_task_copy = groupchat_friend_drinage + '/task/copy/';
const groupchat_friend_path_manage_talk_data = groupchat_friend_path_manage + 'talkData/';//跳转任务数据页面
//账号运营
const account_operation = cloud_path_prefix + '/account';
const new_friend_request = account_operation + '/autoThroughFriend'
const new_friend_remark = account_operation + '/autoRemark'
const new_friend_remark_create = new_friend_remark + '/create'
const new_friend_remark_edit = new_friend_remark + '/edit/'
const new_friend_remark_copy = new_friend_remark + '/copy/'
const new_friend_remark_manage = new_friend_remark + '/manage/'
const new_friend_remark_manage_report = new_friend_remark + '/manage/report/'

//客户触达
//关键词回复
const cloud_customer = cloud_path_prefix + '/customer'
const cloud_customer_keyword = cloud_customer + '/keyword'
const cloud_customer_keyword_create = cloud_customer_keyword + '/create'
const cloud_customer_keyword_edit = cloud_customer_keyword + '/edit/'
const cloud_customer_keyword_copy = cloud_customer_keyword + '/copy/'
const cloud_customer_keyword_manage = cloud_customer_keyword + '/manage/'
const cloud_customer_keyword_manage_report = cloud_customer_keyword_manage + 'report/'
//好友群发
const cloud_customer_friend_groupsend = cloud_customer + '/groupsend'
const cloud_customer_friend_groupsend_manage = cloud_customer_friend_groupsend + '/manage/'
const cloud_customer_friend_groupsend_report = cloud_customer_friend_groupsend_manage + 'report/'
const cloud_customer_friend_groupsend_create = cloud_customer_friend_groupsend + '/create'
const cloud_customer_friend_groupsend_create_for_fission = cloud_customer_friend_groupsend + '/create-for-fission/'
const cloud_customer_friend_groupsend_edit = cloud_customer_friend_groupsend + '/edit/'
const cloud_customer_friend_groupsend_copy = cloud_customer_friend_groupsend + '/copy/'

//客户接待
const cloud_im_chat = "/im/chat";

//sop模板
const customer_sop_template = cloud_customer + '/my_soptemplate';
const customer_sop_template_create = customer_sop_template + '/task/create';//创建任务
const customer_sop_template_edit = customer_sop_template + '/task/edit/';//编辑任务
const customer_sop_template_copy = customer_sop_template + '/task/copy/';//编辑任务
//素材库
const customer_material = cloud_customer + '/material';
const customer_material_create_task = customer_material + '/task/create';//新建
const customer_material_edit_task = customer_material + '/task/edit/';//编辑
//好友sop
const customer_sop_path = cloud_customer + '/sop';//好友sop
const customer_sop_manage = customer_sop_path + '/manage/';
const customer_sop = '/cloud/customer/sop'
const customer_sop_manage_create_task = customer_sop + '/task/create';//创建任务
const customer_sop_manage_create_task_edit = customer_sop + '/task/edit/';//编辑任务
const customer_sop_manage_create_task_copy = customer_sop + '/task/copy/';//编辑任务
const customer_sop_manage_talk_detail = customer_sop_manage + 'talkdetails/';//跳转数据详情

//群sop
const group_chat_path = cloud_path_prefix + '/groupchat';//高效社群文件夹路由
const group_chat_sop = '/cloud/groupchat/sop'
const group_chat_sop_path = group_chat_path + '/sop';//群sop路由
const group_chat_sop_manage = group_chat_sop_path + '/manage/';
const group_chat_sop_manage_talk_details = group_chat_sop_manage + 'talkdetails/';//跳转群sop的数据详情页面
const group_chat_sop_manage_create_task = group_chat_sop + '/task/create';//创建任务
const group_chat_sop_manage_create_task_edit = group_chat_sop + '/task/edit/'//编辑任务
const group_chat_sop_manage_create_task_copy = group_chat_sop + '/task/copy/' //复制任务
const group_chat_sop_manage_talk_admin = group_chat_sop_manage + 'talkAdmin/';//跳转群聊管理
const group_chat_sop_manage_talk_detail = group_chat_sop_manage + 'talkdetails/'; //跳转数据详情

//群管理
const group_chat_manage_path = group_chat_path + '/manage'
//群标签
const group_chat_tag_path = group_chat_path + '/tag'
const group_chat_tag_List = group_chat_tag_path + '/tagList'
//社群群发
const group_chat_send = group_chat_path + '/send'
const group_chat_send_manage = group_chat_send + '/manage/'
const group_chat_send_report = group_chat_send_manage + 'report/'
const group_chat_send_create = group_chat_send + '/create'
const group_chat_send_edit = group_chat_send + '/edit/'
const group_chat_send_copy = group_chat_send + '/copy/'

//群违规检测
const cloud_groupchat_errorcheck = cloud_path_prefix + '/groupchat/errorcheck'
const cloud_groupchat_errorcheck_create = cloud_groupchat_errorcheck + '/create'
const cloud_groupchat_errorcheck_edit = cloud_groupchat_errorcheck + '/edit/'
const cloud_groupchat_errorcheck_manage = cloud_groupchat_errorcheck + '/manage/'
const cloud_groupchat_errorcheck_manage_report = cloud_groupchat_errorcheck_manage + 'report/'


//黑名单
const black_list_path = group_chat_path + '/blacklist'
const black_List = black_list_path + '/blackList'
//白名单
const white_list_path = group_chat_path + '/whitelist'
const white_list_manage = white_list_path + '/manage/'


//高级拉群
const auto_in_vite_path = group_chat_path + '/autoinvite';//高级拉群路由
const auto_in_vite_manage = auto_in_vite_path + '/manage/';
const auto_in_vite_create_task = auto_in_vite_path + '/task/create';//创建任务
const auto_in_vite_create_task_edit = auto_in_vite_path + '/task/edit/';//编辑任务
const auto_in_vite_talk_detail = auto_in_vite_manage + 'talkdetails/';//跳转详情


//群公告
const cloud_groupchat_notice_path = group_chat_path + '/notice'
const cloud_groupchat_notice_manage = cloud_groupchat_notice_path + '/manage/'
const cloud_groupchat_notice_report = cloud_groupchat_notice_manage + 'report/'
const cloud_groupchat_notice_create = cloud_groupchat_notice_path + '/create'
const cloud_groupchat_notice_edit = cloud_groupchat_notice_path + '/edit/'
const cloud_groupchat_notice_copy = cloud_groupchat_notice_path + '/copy/'

//群活码
const cloud_groupchat_livecode_path = group_chat_path + '/rlivecode'
const cloud_groupchat_livecode_manage = cloud_groupchat_livecode_path + '/manage/'
const cloud_groupchat_livecode_manage_roomList = cloud_groupchat_livecode_manage + 'roomlist/'
const cloud_groupchat_livecode_report = cloud_groupchat_livecode_manage + 'report/'
const cloud_groupchat_livecode_create = cloud_groupchat_livecode_path + '/create'
const cloud_groupchat_livecode_edit = cloud_groupchat_livecode_path + '/edit/'
const cloud_groupchat_livecode_copy = cloud_groupchat_livecode_path + '/copy/'

//入群欢迎语
const cloud_groupchat_roomwelmsg_path = group_chat_path + '/roomwelmsg'
const cloud_groupchat_roomwelmsg_manage = cloud_groupchat_roomwelmsg_path + '/manage/'
const cloud_groupchat_roomwelmsg_report = cloud_groupchat_roomwelmsg_manage + 'report/'
const cloud_groupchat_roomwelmsg_create = cloud_groupchat_roomwelmsg_path + '/create'
const cloud_groupchat_roomwelmsg_edit = cloud_groupchat_roomwelmsg_path + '/edit/'
const cloud_groupchat_roomwelmsg_copy = cloud_groupchat_roomwelmsg_path + '/copy/'

//关键词拉群
const cloud_groupchat_kwpullgroup_path = group_chat_path + '/kwpullgroup'
const cloud_groupchat_kwpullgroup_manage = cloud_groupchat_kwpullgroup_path + '/manage/'
const cloud_groupchat_kwpullgroup_report = cloud_groupchat_kwpullgroup_manage + 'report/'
const cloud_groupchat_kwpullgroup_create = cloud_groupchat_kwpullgroup_path + '/create'
const cloud_groupchat_kwpullgroup_edit = cloud_groupchat_kwpullgroup_path + '/edit/'
const cloud_groupchat_kwpullgroup_copy = cloud_groupchat_kwpullgroup_path + '/copy/'

//单向好友
const cloud_cust_operation_path = cloud_path_prefix + '/cust-operation/'
const cloud_cust_operation_oneway_friend_path = cloud_cust_operation_path + 'oneway-friend'
const cloud_cust_operation_manage = cloud_cust_operation_oneway_friend_path + '/manage/'
const cloud_cust_operation_manage_oneway_friend_list = cloud_cust_operation_manage + 'list'
const cloud_cust_operation_manage_oneway_report_list = cloud_cust_operation_manage + 'report'

//cloud_客户管理
const cloud_cust_operation_manage_path = cloud_cust_operation_path + 'cust-manage/'
const cloud_cust_operation_manage_list = cloud_cust_operation_manage_path + 'list'
const cloud_cust_operation_manage_detail = cloud_cust_operation_manage_path + 'detail/'

//子账号创建
const cloud_sub_account_create = '/subAccount/create'
const cloud_sub_account_edit = '/subAccount/edit/'

class CloudPath {

    static getSubAccEdit() {
        return cloud_sub_account_edit
    }

    static getSubAccCreate() {
        return cloud_sub_account_create
    }

    static getCustOperationManagePath() {
        return cloud_cust_operation_manage_path
    }

    static isCustOperationManagePath() {
        return CloudPath.isInPath(CloudPath.getCustOperationManagePath(), CloudPath.getUrl());
    }

    static getCustOperationManageList() {
        return cloud_cust_operation_manage_list
    }

    static getCustOperationManageDetail() {
        return cloud_cust_operation_manage_detail
    }

    static getCustOperationOnewayFriendManage() {
        return cloud_cust_operation_manage
    }

    static getCustOperationOnewayReport() {
        return cloud_cust_operation_manage_oneway_report_list
    }

    static getCustOperationOnewayFriend() {
        return cloud_cust_operation_manage_oneway_friend_list
    }

    static getOneWayFriendPath() {
        return cloud_cust_operation_oneway_friend_path
    }

    static isOneWayFriendPath() {
        return CloudPath.isInPath(CloudPath.getOneWayFriendPath(), CloudPath.getUrl());
    }

    static getGroupChatKWPullGroupReport() {
        return cloud_groupchat_kwpullgroup_report
    }

    static getGroupChatKWPullGroupCreate() {
        return cloud_groupchat_kwpullgroup_create
    }

    static getGroupChatKWPullGroupEdit() {
        return cloud_groupchat_kwpullgroup_edit
    }

    static getGroupChatKWPullGroupCopy() {
        return cloud_groupchat_kwpullgroup_copy
    }

    static getGroupChatKWPullGroupManage() {
        return cloud_groupchat_kwpullgroup_manage
    }

    static getGroupChatKWPullGroup() {
        return cloud_groupchat_kwpullgroup_path
    }

    static isGroupChatKWPullGroup() {
        return CloudPath.isInPath(CloudPath.getGroupChatKWPullGroup(), CloudPath.getUrl());
    }

    static getGroupChatRoomWelMsgCopy() {
        return cloud_groupchat_roomwelmsg_copy
    }

    static getGroupChatRoomWelMsgEdit() {
        return cloud_groupchat_roomwelmsg_edit
    }

    static getGroupChatRoomWelMsgReport() {
        return cloud_groupchat_roomwelmsg_report
    }

    static getGroupChatRoomWelMsgCreate() {
        return cloud_groupchat_roomwelmsg_create
    }

    static getGroupChatRoomWelMsgManage() {
        return cloud_groupchat_roomwelmsg_manage
    }

    static getGroupChatRoomWelMsg() {
        return cloud_groupchat_roomwelmsg_path
    }

    static isGroupChatRoomWelMsg() {
        return CloudPath.isInPath(CloudPath.getGroupChatRoomWelMsg(), CloudPath.getUrl());
    }

    static getGroupChatLivecodeRoomList() {
        return cloud_groupchat_livecode_manage_roomList
    }

    static getGroupChatLivecodeReport() {
        return cloud_groupchat_livecode_report
    }

    static getGroupChatLivecodeCopy() {
        return cloud_groupchat_livecode_copy
    }

    static getGroupChatLivecodeEdit() {
        return cloud_groupchat_livecode_edit
    }

    static getGroupChatLivecodeCreate() {
        return cloud_groupchat_livecode_create
    }

    static getGroupChatLivecodeManage() {
        return cloud_groupchat_livecode_manage
    }

    static getGroupChatLivecode() {
        return cloud_groupchat_livecode_path
    }

    static isGroupChatLivecode() {
        return CloudPath.isInPath(CloudPath.getGroupChatLivecode(), CloudPath.getUrl());
    }

    static getGroupChatNoticeCopy() {
        return cloud_groupchat_notice_copy
    }

    static getGroupChatNoticeEdit() {
        return cloud_groupchat_notice_edit
    }

    static getGroupChatNoticeReport() {
        return cloud_groupchat_notice_report
    }

    static getGroupChatNoticeCreate() {
        return cloud_groupchat_notice_create
    }

    static getGroupChatNoticeManage() {
        return cloud_groupchat_notice_manage
    }

    static getGroupChatNotice() {
        return cloud_groupchat_notice_path
    }

    static isGrouChatNotic() {
        return CloudPath.isInPath(CloudPath.getGroupChatNotice(), CloudPath.getUrl());
    }

    static getGroupChatErrorCheckReport() {
        return cloud_groupchat_errorcheck_manage_report
    }

    static getGroupChatErrorCheckEdit() {
        return cloud_groupchat_errorcheck_edit
    }

    static getGroupChatErrorCheckCreate() {
        return cloud_groupchat_errorcheck_create
    }

    static getGroupChatCloudErrorCheck() {
        return cloud_groupchat_errorcheck
    }

    static isCloudGroupChatErrorCheck() {
        return CloudPath.isInPath(CloudPath.getGroupChatCloudErrorCheck(), CloudPath.getUrl());
    }

    static getGroupChatErrorCheckManage() {
        return cloud_groupchat_errorcheck_manage
    }

    static getGroupChatSendEdit() {
        return group_chat_send_edit
    }

    static getGroupChatSendCopy() {
        return group_chat_send_copy
    }

    static getGroupChatSendCreate() {
        return group_chat_send_create
    }

    static getGroupChatSendReport() {
        return group_chat_send_report
    }

    static getGroupChatSendManage() {
        return group_chat_send_manage
    }

    static getGroupChatsend() {
        return group_chat_send
    }

    static isGroupChatsend() {
        return CloudPath.isInPath(CloudPath.getGroupChatsend(), CloudPath.getUrl());
    }

    static getGroupChatTagList() {
        return group_chat_tag_List
    }

    static isGroupChatTagList() {
        return CloudPath.isInPath(CloudPath.getGroupChatTagList(), CloudPath.getUrl());
    }

    static isGroupChatManage() {
        return CloudPath.isInPath(CloudPath.getGroupChatManage(), CloudPath.getUrl());
    }

    static getGroupChatManage() {
        return group_chat_manage_path
    }

    static isGroupChatManage() {
        return CloudPath.isInPath(CloudPath.getGroupChatManage(), CloudPath.getUrl());
    }

    static getCloudGroupSendReport() {
        return cloud_customer_friend_groupsend_report
    }

    static getCloudGroupSendEdit() {
        return cloud_customer_friend_groupsend_edit
    }

    static getCloudGroupSendCopy() {
        return cloud_customer_friend_groupsend_copy
    }

    static getCloudGroupSendCreateForFission() {
        return cloud_customer_friend_groupsend_create_for_fission
    }

    static getCloudGroupSendCreate() {
        return cloud_customer_friend_groupsend_create
    }

    static getCloudGroupsendManage() {
        return cloud_customer_friend_groupsend_manage
    }

    static getCloudFriendGroupsend() {
        return cloud_customer_friend_groupsend
    }

    static isCloudFriendGroupsend() {
        return CloudPath.isInPath(CloudPath.getCloudFriendGroupsend(), CloudPath.getUrl());
    }

    static getKeywordReport() {
        return cloud_customer_keyword_manage_report
    }

    static getKeywordEdit() {
        return cloud_customer_keyword_edit
    }

    static getKeywordCopy() {
        return cloud_customer_keyword_copy
    }

    static getKeywordCreate() {
        return cloud_customer_keyword_create
    }

    static getCloudKeyword() {
        return cloud_customer_keyword
    }

    static isCloudKeyword() {
        return CloudPath.isInPath(CloudPath.getCloudKeyword(), CloudPath.getUrl());
    }

    static getCloudCustomerManage() {
        return cloud_customer_keyword_manage
    }

    static getAutoRemarkCopy() {
        return new_friend_remark_copy
    }

    static getAutoRemarkEdit() {
        return new_friend_remark_edit
    }

    static getAutoRemarkCreate() {
        return new_friend_remark_create
    }

    static getNewFriendRemarkManageReport() {
        return new_friend_remark_manage_report
    }

    static getNewFriendRemarkManage() {
        return new_friend_remark_manage
    }

    static newFriendRemark() {
        return new_friend_remark
    }

    static isNewFriendRemark() {
        return CloudPath.isInPath(CloudPath.newFriendRemark(), CloudPath.getUrl());
    }

    static newFriendRequest() {
        return new_friend_request
    }

    static isNewFriendRequest() {
        return CloudPath.isInPath(CloudPath.newFriendRequest(), CloudPath.getUrl());
    }

    static getSeatPath() {
        return cloud_path_prefix + '/seat'
    }

    static isSeatPath() {
        return CloudPath.isInPath(CloudPath.getSeatPath(), CloudPath.getUrl());
    }

    static getUrl() {
        let url = window.location.href;
        if (url.endsWith('/')) {
            url = url.substring(0, url.length - 1);
        }
        return url;
    }

    static isInPath(path, url) {
        if (url.indexOf(path) > 0) {
            return true;
        }
        return false;
    }

    //话术库
    static getTalklibPath() {
        return talklib_path
    }

    static isSeatTalklibPath() {
        return CloudPath.isInPath(CloudPath.getTalklibPath(), CloudPath.getUrl());
    }

    //新建话术库
    static getCreateTalklib() {
        return talklib_create
    }

    //编辑话术库
    static getEditTalkLib() {
        return talllib_edit
    }

    // 跳转 拓客引流-手机号加好友
    static getMobileFriend() {
        return mobile_friend_path;
    }

    static isMobileFriend() {
        return CloudPath.isInPath(CloudPath.getMobileFriend(), CloudPath.getUrl());
    }

    static getDrainageMobileFriendManage() {
        return mobile_friend_path_manage
    }

    //拓客引流创建任务页面
    static getMobileFriendCreateTask() {
        return mobile_friend_path_manage_create_task
    }

    //拓客引流编辑任务页面
    static getMobileFriendTaskEdit() {
        return mobile_friend_path_manage_create_task_edit
    }

    static getMobileFriendTaskCopy() {
        return mobile_friend_path_manage_create_task_copy
    }

    //拓客引流跳转详情页面
    static getMobileFriendTalkDetail() {
        return mobile_friend_path_manage_talk_details
    }

    // 跳转 拓客引流-群加好友
    static getGroupChatFriend() {
        return groupchat_friend_path;
    }

    static isGroupChatFriend() {
        return CloudPath.isInPath(CloudPath.getGroupChatFriend(), CloudPath.getUrl());
    }

    static getDrainageGroupChatFriendManage() {
        return groupchat_friend_path_manage
    }

    static getGroupChatFriendCreateTask() {
        return groupchat_friend_path_manage_create_task
    }

    //跳转群加好友的编辑
    static getGroupChatFriendEdit() {
        return groupchat_friend_path_manage_create_task_edit
    }

    //跳转群加好友的复制
    static getGroupChatFriendTaskCopy() {
        return groupchat_friend_path_manage_create_task_copy
    }

    static getGroupChatFriendTalkData() {
        return groupchat_friend_path_manage_talk_data
    }

    //sop模板
    static getCustomerSopTemplate() {
        return customer_sop_template
    }

    static isCustomerSopTemplate() {
        return CloudPath.isInPath(CloudPath.getCustomerSopTemplate(), CloudPath.getUrl());
    }

    static getCustomerSopTemplateCreateTask() {
        return customer_sop_template_create
    }

    static getCustomerSopTemplateEdit() {
        return customer_sop_template_edit
    }

    static getCustomerSopTemplateCopy() {
        return customer_sop_template_copy
    }

    //素材库
    static getCustomerMaterial() {
        return customer_material
    }

    static isCustomerMaterial() {
        return CloudPath.isInPath(CloudPath.getCustomerMaterial(), CloudPath.getUrl());
    }

    //新建素材
    static getNewMaterial() {
        return customer_material_create_task
    }

    //编辑素材
    static getMediaEditTask() {
        return customer_material_edit_task
    }

    //好友sop
    static getCustomerSop() {
        return customer_sop_path
    }

    static isCustomerSop() {
        return CloudPath.isInPath(CloudPath.getCustomerSop(), CloudPath.getUrl());
    }

    static getCustomerSopManage() {
        return customer_sop_manage
    }

    static getCustomerSopCreateTask() {
        return customer_sop_manage_create_task
    }

    //编辑好友sop
    static getCustomerSopTaskEdit() {
        return customer_sop_manage_create_task_edit
    }

    //复制好友sop
    static getCustomerSopTaskCopy() {
        return customer_sop_manage_create_task_copy
    }

    //跳转数据详情
    static getCustomerSopTaskDetail() {
        return customer_sop_manage_talk_detail
    }

    //群sop
    static getGroupSop() {
        return group_chat_sop_path
    }

    static isGroupSop() {
        return CloudPath.isInPath(CloudPath.getGroupSop(), CloudPath.getUrl());
    }

    static getGroupChatSopManage() {
        return group_chat_sop_manage
    }

    static getGroupSopCreateTask() {
        return group_chat_sop_manage_create_task
    }

    //跳转群sop的群聊管理
    static getGroupChatSopTalkAdmin() {
        return group_chat_sop_manage_talk_admin
    }

    //跳转群SOP的数据
    static getGroupChatSopTaskDetail() {
        return group_chat_sop_manage_talk_detail
    }

    //编辑SOP任务
    static getGroupChatSopTaskEdit() {
        return group_chat_sop_manage_create_task_edit
    }

    //复制Sop任务
    static getGroupChatSopTaskCopy() {
        return group_chat_sop_manage_create_task_copy
    }


    //黑名单
    static getBlackList() {
        return black_List
    }

    static isBlackList() {
        return CloudPath.isInPath(CloudPath.getBlackList(), CloudPath.getUrl());
    }

    //白名单
    static getWhiteList() {
        return white_list_path
    }

    static isWhiteList() {
        return CloudPath.isInPath(CloudPath.getWhiteList(), CloudPath.getUrl());
    }

    static getWhiteListManage() {
        return white_list_manage
    }

    //客户接待
    static getImChat() {
        return cloud_im_chat;
    }

    static isImChat() {
        return CloudPath.isInPath(CloudPath.getImChat(), CloudPath.getUrl());
    }

    //高级拉群
    static getAutoInvite() {
        return auto_in_vite_path
    }

    static isAutoInvite() {
        return CloudPath.isInPath(CloudPath.getAutoInvite(), CloudPath.getUrl());
    }

    static getAutoInviteManage() {
        return auto_in_vite_manage
    }

    //高级拉群创建任务
    static getAutoInviteCreateTask() {
        return auto_in_vite_create_task
    }

    //高级拉群编辑任务
    static getAutoInviteCreateTaskEdit() {
        return auto_in_vite_create_task_edit
    }

    //跳转详情
    static getAutoInviteTalkDetail() {
        return auto_in_vite_talk_detail
    }
}

export default CloudPath